// export const environment = {
//   production: true
// };

export const environment = {"production":"true","version":"2.4.25"};